import { DialogConfig } from '../models/dialogconfig';
import { v4 } from 'uuid';
import { HttpHeaders } from '@angular/common/http';
import moment from 'moment';
import * as CryptoJS from 'crypto-js';
//const CryptoJS = require('crypto-js');

import { AppSettingsService } from './../services/app-settings.service';

export interface IAuthProvider {
    buildAuthRequestHeader(config: any): any;
    buildAuthorizedResponseObject(status: number, response: any): any;
    buildRequestOptions(config: any): any;        
}

export class DialogAuthProvider implements IAuthProvider
{
    private _config: DialogConfig;
    private _token: string;
    private appSettings: AppSettingsService

    public constructor(config: DialogConfig, appSettings: AppSettingsService) {
        this._config = config;
        this.appSettings = appSettings;
    }

    public buildAuthRequestHeader(options: any): any {
        options.body = JSON.stringify(this._config.Claim); 
        const h = new HttpHeaders()
        .set("Authorization",this._generateAuthorizationHeader(options))
        .set("Content-Type", "application/json;charset=UTF-8");
        options.headers = h;
        return options;
    }

    public buildAuthorizedResponseObject(response: any): any {        
        const res = response;       
        let  authResponse = {};
        if(response) {
            authResponse = {
                id : res.id,
                token : res.token,
                expires : new Date(res.expires),
                lastLogin : res.updatedOn ? new Date(res.updatedOn) : new Date(),
            };            
        }        
        return authResponse;
    }

    public buildRequestOptions(options: any): any {                             
        this._token = options.token;        
        //console.log("token:" + options.token);
        const lastLoginDate = moment(options.lastLogin).format("YYYY-MM-DD HH:mm:ss").toString().replace(' ','T');
        options.method = 'get';
        options.url = this.appSettings.MessageCenterBaseUrl.concat(`/api/notification/Count?UserId=${options.id}&LastLogin=${lastLoginDate}`);
        const opts =  ({            
            responseType: "json",
            headers: new HttpHeaders({
                Authorization: this._generateAuthorizationHeader(options),
                axx: options.token 
            }),
            method: options.method,
            url: options.url
        });                             
        return opts;
    }
    
    private _generateAuthorizationHeader(options: any) {              
        const nonce = v4(),
            timestamp = Date.now(),
            signature = this._config.AppKey +
            options.method.toLowerCase() +
            encodeURIComponent(options.url).toLowerCase() +
            timestamp +
            nonce +
            (options.body ? CryptoJS.enc.Base64.stringify(CryptoJS.MD5(options.body)): '');   
//            console.log("Options Body:" + options.body);
//            console.log("Signature:" + signature);
            const hashInBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(signature, this._config.AppSecret)),            
            auth = "amx " + this._config.AppKey + ":" + hashInBase64 + ":" + nonce + ":" + timestamp + ":" + (this._token || "");
//            console.log("uri:" + encodeURIComponent(options.url).toLowerCase())
//            console.log("Hash:" + hashInBase64);
//            console.log("Timestamp:" + timestamp);
//            console.log("Nonce:" + nonce);
        return auth;
    }
    
}